/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-console */
/* eslint-disable guard-for-in */
import EventHandler from '../../../utils/dom/event-handler';
import { Events } from '../../../utils/dom/html-events';
import SelectorEngine from '../../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../../utils/request';
import FormGenerator, { FormTypes } from '../../../components/FormGenerator';
import { startLoadingAnimation } from '../../../utils/dom/loading';
import Manipulator from '../../../utils/dom/manipulator';

const SAFEGUARD_WRAPPER = '.p-safeguard-form';
const SAFEGUARD_FORM_WRAPPER = '.p-safeguard-form-wrapper';
const SAFEGUARD_FORM = '.p-safeguard-form-form';
const SAFEGUARD_FORM_BUTTON = '.p-safeguard-form-button';

const IS_LOCAL = false;
const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

class SafeGuarding {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SAFEGUARD_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.formWrapper = SelectorEngine.findOne(SAFEGUARD_FORM_WRAPPER, this._wrapper);
		this.form = SelectorEngine.findOne(SAFEGUARD_FORM, this._wrapper);
		this.formButton = SelectorEngine.findOne(SAFEGUARD_FORM_BUTTON, this._wrapper);
		this._errorContainer = SelectorEngine.findOne('.p-safeguard-form-wrapper-error-container', this._wrapper);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});
		this.getFormDetails();
	}

	async getFormDetails() {
		try {
			const url = '/api/coachdetails/getcertificateuploadform?type=safeguarding';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.form, {
			questions: stepsData,
			totalSteps: 4,
			hasSeparator: false,
			formType: FormTypes.SectionForm,
			isHideProgress: true,
			isRenderDependentQuestion: false
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});
		EventHandler.on(this.formButton, Events.Click, async () => {
			const isFormValid = await this.formGenerator.formValidation();
			if (isFormValid) {
				console.log('Answers :', this.answerList);
				this.submitSupportForm(this.answerList);
			}
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					source: ['Safeguarding Submission'],
					...this.answerList,
					...formatObject
				};
			}
		}
	}

	async submitSupportForm(answers) {
		startLoadingAnimation(true);
		const formData = new FormData();
		const payload = {
			courseName: answers.courseName,
			courseProvider: answers.courseProvider,
			completionDate: answers.courseCompletionDate
		};
		formData.append('json', JSON.stringify(payload));
		formData.append('attachment', answers.certificateUpload[0]);

		try {
			const url = `/api/coachdetails/SubmitCertificate?type=safeguarding`;
			const responseData = await Request.postFormData(url, formData);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this.form, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this.form, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this.form, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		}
	}
}

const globalSafeGuarding = new SafeGuarding();
export default globalSafeGuarding;
